/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Boundary_HomeInputs */

const en_us2_errors_boundary_home = /** @type {(inputs: Errors_Boundary_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to the start`)
};

const pt_br2_errors_boundary_home = /** @type {(inputs: Errors_Boundary_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao início`)
};

const es_419_errors_boundary_home = /** @type {(inputs: Errors_Boundary_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al inicio`)
};

const pt_pt2_errors_boundary_home = /** @type {(inputs: Errors_Boundary_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao início`)
};

const fr_fr2_errors_boundary_home = /** @type {(inputs: Errors_Boundary_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à l'accueil`)
};

const de_de2_errors_boundary_home = /** @type {(inputs: Errors_Boundary_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Start`)
};

const it_it2_errors_boundary_home = /** @type {(inputs: Errors_Boundary_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna all'inizio`)
};

/**
* | output |
* | --- |
* | "Back to the start" |
*
* @param {Errors_Boundary_HomeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const errors_boundary_home = /** @type {((inputs?: Errors_Boundary_HomeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Boundary_HomeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_errors_boundary_home(inputs)
	if (locale === "es-419") return es_419_errors_boundary_home(inputs)
	if (locale === "pt-PT") return pt_pt2_errors_boundary_home(inputs)
	if (locale === "fr-FR") return fr_fr2_errors_boundary_home(inputs)
	if (locale === "de-DE") return de_de2_errors_boundary_home(inputs)
	if (locale === "it-IT") return it_it2_errors_boundary_home(inputs)
	return en_us2_errors_boundary_home(inputs)
});
export { errors_boundary_home as "errors-boundary.home" }